export class ShipmentPackage {
    Id: string | null;
    Tenant: number | null;
    PackageTypeId: string | null;
    PackageTypeCode: string | null;
    PackageTypeName: string | null;
    ContainerNumber: string | null;
    IsContainer: boolean | null;
    Volume: number | null;
    PackageTypeVolume: number | null;
    Weight: number | null;
    ShipperSeal: string | null;
    LastStatusName: string | null;
}